export default __webpack_public_path__ + "static/media/config-hris-exit-policy.ba17d7ad.svg";